module.exports = __webpack_public_path__ + "img/upload-doc.2ade8d96.svg";